export default "__VITE_ASSET__BcKfZ9wd__"